<template>
  <BaseModal :is-open="isOpen" :title="modalTitle" :hide-body="!body" @close="$emit('cancel')">
    <slot>
      {{ body }}
    </slot>
    <template #footer>
      <a
        href="#"
        class="btn btn-regular"
        style="margin-bottom: 0 !important;"
        @click.prevent="$emit('cancel')"
      >
        <i class="icon-close" style="margin-right: 4px;"></i> {{ $t('common.no') }}
      </a>
      <a href="#" class="btn" @click.prevent="$emit('confirm')">
        <i class="icon-check" style="margin-right: 4px;"></i> {{ $t('common.yes') }}
      </a>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from './base/BaseModal';

export default {
  name: 'ConfirmationModal',

  components: { BaseModal },

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
  },

  computed: {
    modalTitle() {
      return this.title || this.$t('common.confirmAction');
    },
  },
};
</script>
